import type { Course, UserRole } from './types';

export const COLORS = {
  // Brand primaries
  blue: '#0B3C5D',
  orange: '#FF7800',
  orangeText: '#CC6000',
  ink: '#0A0F14',
  bg: '#F7FAFC',
  white: '#FFFFFF',
  // Semantic
  success: '#16A34A',
  warning: '#F59E0B',
  error: '#DC2626',
  info: '#3B82F6',
} as const;

/** Active ANSUT roles only — legacy roles kept in Prisma enum for DB compat but hidden from UI */
export const ACTIVE_ROLES: UserRole[] = [
  'SUPER_USER_ADMIN',
  'ADMIN_ANSUT',
  'TEAM_ANSUT',
  'ADMIN_COLLEGE',
  'EQUIPE_COLLEGE',
  'FORMATEUR_PRINCIPAL',
  'FORMATEUR_ASSISTANT',
  'APPRENANT',
];

export const ROLE_LABELS: Partial<Record<UserRole, string>> = {
  SUPER_USER_ADMIN: 'Super User Admin',
  ADMIN_ANSUT: 'Admin ANSUT',
  TEAM_ANSUT: 'Équipe ANSUT',
  ADMIN_COLLEGE: 'Admin Collège',
  EQUIPE_COLLEGE: 'Équipe Collège',
  FORMATEUR_PRINCIPAL: 'Formateur Principal',
  FORMATEUR_ASSISTANT: 'Formateur Assistant',
  APPRENANT: 'Apprenant',
};

const PM_PERMISSIONS = [
  'users:read', 'users:write', 'users:import',
  'courses:read', 'courses:write',
  'certificates:read', 'certificates:validate',
  'reports:read', 'reports:export',
  'dashboard:pm',
  'monitoring:read',
  'roles:manage',
];

export const ROLE_PERMISSIONS: Partial<Record<UserRole, string[]>> = {
  SUPER_USER_ADMIN: ['*'],
  ADMIN_ANSUT: PM_PERMISSIONS,
  TEAM_ANSUT: [
    'users:read', 'users:write',
    'courses:read', 'courses:write',
    'certificates:read', 'certificates:validate',
    'reports:read', 'dashboard:pm',
    'monitoring:read',
  ],
  ADMIN_COLLEGE: [
    'users:read', 'users:write',
    'students:read',
    'courses:read',
    'progress:read',
    'reports:read',
    'dashboard:college',
  ],
  EQUIPE_COLLEGE: [
    'students:read', 'students:write',
    'courses:read',
    'progress:read', 'progress:write',
    'dashboard:college',
  ],
  FORMATEUR_PRINCIPAL: [
    'courses:read', 'courses:write',
    'lessons:read', 'lessons:write',
    'students:read',
    'certificates:validate',
    'dashboard:formateur',
  ],
  FORMATEUR_ASSISTANT: [
    'courses:read',
    'lessons:read', 'lessons:write',
    'students:read',
    'notes:write',
    'dashboard:formateur',
  ],
  APPRENANT: [
    'courses:read',
    'progress:read', 'progress:write',
    'certificates:read',
    'challenges:read', 'challenges:submit',
    'ai:chat',
    'dashboard:beneficiaire',
  ],
};

export const ADMIN_ROLES: UserRole[] = [
  'SUPER_USER_ADMIN',
  'ADMIN_ANSUT',
  'TEAM_ANSUT',
  'ADMIN_COLLEGE',
];

export const FORMATEUR_DASHBOARD_ROLES: UserRole[] = [
  'SUPER_USER_ADMIN',
  'ADMIN_ANSUT',
  'TEAM_ANSUT',
  'FORMATEUR_PRINCIPAL',
  'FORMATEUR_ASSISTANT',
];

export const LEARNER_ROLES: UserRole[] = ['APPRENANT'];

export const MANAGED_USER_ROLES: UserRole[] = [
  'APPRENANT',
  'FORMATEUR_PRINCIPAL',
  'FORMATEUR_ASSISTANT',
  'ADMIN_COLLEGE',
  'EQUIPE_COLLEGE',
  'TEAM_ANSUT',
  'ADMIN_ANSUT',
];

export const COURSES_SEED: Omit<Course, 'lessonsCount' | 'enrollmentCount'>[] = [
  {
    id: 'nzassa-cicn-course-1',
    title: 'NzassaLearn CICN — Bingerville 2026',
    description: 'Programme de 8 sessions de compétences numériques pour lycéennes (méthodologie ASUP)',
    level: 'BEGINNER',
    duration: 720,
    published: true,
    order: 1,
  },
];

export const PHONE_REGEX = /^\+225\d{10}$/;

export const JWT_EXPIRATION_DAYS = 30;

export const GAMIFICATION_POINTS: Record<string, number> = {
  LESSON_COMPLETED: 10,
  QUIZ_PASSED: 25,
  CHALLENGE_SUBMITTED: 50,
  DAILY_LOGIN: 5,
  STREAK_7_DAYS: 100,
  COURSE_COMPLETED: 200,
  FIRST_LOGIN: 10,
};
